import React from "react"; // ✅ REQUIRED for SSR and JSX

/**
 * A wrapper to expose the methods to turn on/off spinner.
 * 
 * Props:
 * - Component (component): a component, new methods will be spread by props
 */
export const withSpinner = (Component) => {
    const Wrapper = (props) => {
        return (
            <Component
                showLoadingSpinner={(value) => { 
                    props.dispatch({
                        type: value ? "SET_LOADER_START" : "SET_LOADER_STOP",
                        payload: value
                    });
                }}
                showProcessingSpinner={(value) => { 
                    props.dispatch({
                        type: value ? "SET_PROCESSING_START" : "SET_PROCESSING_STOP",
                        payload: value
                    });
                }}
                {...props}
            />
        );
    };
    return Wrapper;
};